import { GridContainer } from 'libs/ui';
import { Events } from 'grids/events/events';

export const EventsWrapper = (props) => {
  return (
    <GridContainer>
      <Events {...props} />
    </GridContainer>
  );
};
